import Axios from "axios";
import { ApiBaseUrl, ChatUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  ChatGetNotificationsResponse,
  ChatSearchRequest,
  ChatSearchResponse,
  ConfirmHasTheUserSeenRequest,
  DeleteChatAttachmentRequest,
  DeleteMessageRequest,
  GetLoanCommentsChangesRequest,
  GetLoanCommentsChangesResponse,
  GetLoanCommentsResponse,
  GetUsersReponse,
  SendMessageRequest,
} from "../models/chat.model";
import { ReferenceKey } from "../models/cartable.model";

export const GetLoanComments = (
  data: ReferenceKey
): Promise<GetLoanCommentsResponse[]> => {
  return Axios.post<ApiResultModel<GetLoanCommentsResponse[]>>(
    ApiBaseUrl + ChatUrl + "/GetLoanComments",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanCommentsChanges = (
  data: GetLoanCommentsChangesRequest
): Promise<GetLoanCommentsChangesResponse> => {
  return Axios.post<ApiResultModel<GetLoanCommentsChangesResponse>>(
    ApiBaseUrl + ChatUrl + "/GetLoanCommentsChanges",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetUsers = (): Promise<GetUsersReponse[]> => {
  return Axios.post<ApiResultModel<GetUsersReponse[]>>(
    ApiBaseUrl + ChatUrl + "/GetUsers"
  ).then((result) => {
    return result.data.data;
  });
};

// export const SendMessage = (data: SendMessageRequest): Promise<boolean> => {
//   return Axios.post<ApiResultModel<boolean>>(
//     ApiBaseUrl + ChatUrl + "/SendMessage",
//     data
//   ).then((result) => {
//     return result.data.data;
//   });
// };

export const SendMessage = async (
  data: SendMessageRequest
): Promise<boolean> => {
  const formData = new FormData();

  formData.append("messageText", data.messageText);
  formData.append("ReferenceKey", data.referenceKey!);
  formData.append("referrerMessageKey", data.referrerMessageKey!);
  const suppList = data.mentionedUserIds;
  suppList?.forEach((item: any) => {
    formData.append("mentionedUserIds", item);
  });
  // formData.append("files", data.files);
  const attach = data.files;
  attach?.forEach((item: any) => {
    formData.append("files", item);
  });

  // formData.append("files", URL.createObjectURL(data.files));

  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + ChatUrl + "/SendMessage",
    formData
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteMessage = (data: DeleteMessageRequest): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + ChatUrl + "/Delete",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const ChatSearch = (
  data: ChatSearchRequest
): Promise<ApiResultModel<ChatSearchResponse[]>> => {
  return Axios.post<ApiResultModel<ChatSearchResponse[]>>(
    ApiBaseUrl + ChatUrl + "/Search",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetChatNotifications = (): Promise<ChatGetNotificationsResponse[]> => {
  return Axios.post<ApiResultModel<ChatGetNotificationsResponse[]>>(
    ApiBaseUrl + ChatUrl + "/GetNotifications"
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteChatAttachment = (
  data: DeleteChatAttachmentRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + ChatUrl + "/DeleteAttachment",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const ConfirmHasTheUserSeen = (
  data: ConfirmHasTheUserSeenRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + ChatUrl + "/ConfirmTheUserSeen",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const HasTheUserAnyMessage = (): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + ChatUrl + "/HasTheUserAnyMessage"
  ).then((result) => {
    return result.data.data;
  });
};
